<template>
  <v-list-item>
    <v-list-item-content>
      <DateInput
        v-model="value"
        :disabled="loading"
        :label="description"
        @input="changed = true"
      />
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            :loading="saving"
            :disabled="loading || saving || noChanges"
            @click="save"
            icon
            color="primary"
          >
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </template>
        <span>Änderungen speichern</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            :loading="saving"
            :disabled="loading || saving || noChanges"
            @click="reset"
            icon
          >
            <v-icon>mdi-cancel</v-icon>
          </v-btn>
        </template>
        <span>Änderungen rückgängig machen</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { defineComponent } from "vue";
import DateInput from "common/components/DateInput.vue";
export default defineComponent({
  name: "SettingComponent",
  components: { DateInput },
  props: ["description", "settings", "field", "loading"],
  data() {
    return {
      saving: false,
      value: null,
      changed: false,
    };
  },
  computed: {
    noChanges() {
      if (!this.settings || !this.field) return true;
      return this.value === this.settings[this.field];
    },
  },
  watch: {
    settings: {
      handler(newSettings) {
        if (newSettings && this.field && !this.changed) {
          this.value = newSettings[this.field];
        }
      },
      immediate: true,
    },
  },
  methods: {
    async save() {
      this.saving = true;
      await this.apiPost({
        resource: "onboarding/settings",
        data: {
          key: this.field,
          value: this.value,
        },
      });
      this.saving = false;
      this.$emit("updated");
    },
    reset() {
      if (this.settings && this.field) {
        this.value = this.settings[this.field];
      }
    },
  },
});
</script>
